import * as types from './mutation-types'
import { convertIntToBoolean } from '@/helpers'

let defaultObject = () => ({
  data: {}
})

export default {
  [types.SET_TRANSFER] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    convertIntToBoolean(payload, ['status'])
    state.transfer = payload
  },
  [types.SET_TRANSFERS] (state, payload) {
    state.transfers = []
    if (payload.data.length > 0) {
      for (let transfer of payload.data) {
        convertIntToBoolean(transfer, ['status'])
      }
      state.transfers = payload.data
    }
    state.pagination = payload.meta.pagination
  }
}
